// extracted by mini-css-extract-plugin
export var formContainer = "_c7-0";
export var message = "_c7-1";